import type { Lang } from "../../i18n/I18nProvider";

/** Short local date for a timestamp string; falls back to the raw text when it does not parse. */
export function formatDate(value: string, lang: Lang): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString(lang === "sr" ? "sr-Latn" : "en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}
